import React from 'react';

export default function NotFound() {
  return (
    <p>Not Found</p>
  );
}
